import MUIDataTable from 'mui-datatables';
import { useDispatch } from 'react-redux';
import React, {useState, useEffect} from 'react';
import Axios from '../../../axios/Axios';
import { showSnackbar } from '../../redux/features/appSlice';
import ViewSpocBatch from "../modals/ViewSpocBatch";
import { Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import { MoreVert } from '@material-ui/icons';
import { Dropdown } from 'react-bootstrap';
import CommentsModalReuse from '../../Reusable/CommentsModalReuse';
import { ShowFullText } from '../../Reusable/ShowMoreText';
import axios from 'axios';


export const SpocList = () => {

    const dispatch = useDispatch();
    const [spocList, setSpocList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [viewSpocModal, setViewSpocModal] = useState(false);
    const [isDataFetchError, setIsDataFetchError] = useState(false);
    const [openDialog, handleDialog] = useState({open: false, deactivate: null});
    const [ commentsModal, setCommentsModal ] = useState(false);


     // for comment section 
  const [reloadComments, setReloadComments] = useState(false);
  const handleCommentsModalClose = () => {
    setReloadComments(!reloadComments);
  };
    //GET Request : To fetch spoc list
    useEffect(() => {
      const controller = axios.CancelToken.source();

      (async () => {
          try{
              const options = {
                  method: "get",
                  url: "adminlogin/get/spocs",
                  auth: true,
                  data: null,
                  token:{cancelToken: controller.token}
              };
          
                const {data} = await Axios(
                  options.method,
                  options.url,
                  options.auth,
                  options.data,
                  options.token,
              );
              setSpocList(data);
  
          }catch(err){
            if(!axios.isCancel(err)){
              setIsDataFetchError(true)
              dispatch(
                  showSnackbar({
                    message: "Couldn't able to retrieve Spoc list",
                    severity: "error",
                  })
              );
            }
          }
      })()
      return () => {
        controller.cancel();
    }
  }, [dispatch, reloadComments]);

  //Function : Unbatch the spoc and deactivate
  const unbatchAndDeactivate = async (spocId) => {
    try{
      const response = await Axios("put", `spoc/deactivate/spoc/batch/${spocId}`, true, null);
      if(response.status === 200){
        // window.location.reload();
        handleCommentsModalClose()
        dispatch(
          showSnackbar({
            message: "Spoc Deactivated successfully.",
            severity: "success",
          })
        );
      }else if (response.status === 202){
        dispatch(
          showSnackbar({
            message: response.data,
            severity: "error",
          })
        );
      }
    }catch(error){
      dispatch(
        showSnackbar({
          message: "Error occured! Unable to Activate/Deactivate spoc",
          severity: "error",
        })
      );
    }
  }

  //Enable/Disable spoc feature : To check if the spoc is assigned to a batch
  const checkSpocAssignedToBatch = async (spocId, spocStatus) => {
    try{  
      if(spocStatus === "active"){
        const response = await Axios("get", `spoc/check/spoc/batch/${spocId}`, true, null);
        const {data} = response;
        // console.log(response);
        if(!data.result){
          handleDialog({
            open: true, 
            deactivate: () => unbatchAndDeactivate(spocId),
            dialogText: "By deactivating this spoc, will no longer available for further assignments. Do you want to continue ?"
          });
          // await unbatchAndDeactivate(spocId);
        }else{
          handleDialog({
            open: true, 
            deactivate: () => unbatchAndDeactivate(spocId),
            dialogText: "By deactivating this spoc, the assigned batches will no longer maintained by this spoc. Do you want to continue?"
          });
        }
      }else{
        const unbatch = await Axios("put", `spoc/activate/spoc/admin/set/${spocId}`, true, null);
        if(unbatch.status === 200){
         // window.location.reload();
         handleCommentsModalClose()
          dispatch(
            showSnackbar({
              message: "Spoc activated successfully.",
              severity: "success",
            })
          );
        }
      }
    }catch(error){
      console.log(error);
      dispatch(
        showSnackbar({
          message: "Error occured! Unable to Activate/Deactivate spoc",
          severity: "error",
        })
      );
    }
  }

const columns = [
    {
      name: "user_id",
      label: "User Id",
      options: {
        display: false,
        filter: true,
        sort: true,
        sortDirection: "desc",
      }
    },
    {
      name: "first_name",
      label: "First name",
      options: {
      filter: true,
      sort: true,
      customBodyRender: value => value !== null ? value : "-"
      }
    },
    {
      name: "last_name",
      label: "Last name",
      options: {
      filter: true,
      sort: true,
      customBodyRender: value => value !== null ? value : "-"
      }
  },
    {
        name: "username",
        label: "Username",
        options: {
        filter: true,
        sort: true,
        customBodyRender: value => value ? <Chip color='primary' label={value} onClick={() => setViewSpocModal(true)} /> : "-"
        }
    },
    {
      name: "email_id",
      label: "Email",
      options: {
      filter: true,
      sort: false,
      customBodyRender: value => value !== null ? value : "-"
      }
    },
    {
      name: "role",
      label: "Role",
      options: {
      filter: true,
      sort: true,
      }
    },
    {
      name: "phone_no",
      label: "Contact no",
      options: {
      filter: true,
      sort: true,
      customBodyRender: value => value !== null ? value : "-"
      }
    },
    {
      name: "user_comment_desc",
     label:"Comments",
     options: {
      filter: false,
      filterType: "dropdown",
      customBodyRender :(value) =>{
        // console.log(value);
        return (
          <ShowFullText title={value}>
           <Typography variant='p' sx={{ cursor:'pointer'}}>
            {value && value.length> 25? `${value.substring(0,25)}...` : value}
           </Typography>
          </ShowFullText>
        )
      }
    },
    },
    {
      name: "status",
      label: "Status",
      options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
          return (
            <div>
              {value === "active" ? (
                <div
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                    textTransform: "capitalize"
                  }}
                >
                  {value}
                </div>
              ) : 
              (
                <div
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                    textTransform: "capitalize"
                  }}
                >
                  {value}
                </div>
              )}
            </div>
          );
        },
      }
    },
    {
      name: "status",
      label: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        download: false,
        // empty: true,
        customBodyRender: (value, data) => {
          // console.log(data);
          let spocId = data.rowData[0];
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVert />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setCommentsModal(true)}>
                    Create / View comment
                  </Dropdown.Item>
                  <Dropdown.Item 
                    onClick={() => checkSpocAssignedToBatch(spocId, value)}
                  >
                    {value === "active" ? "Deactivate spoc" : "Activate spoc"}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    },
];
    
const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 20],
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    jumpToPage: true,
    onRowClick: (rowData) => {
      setTableData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
  }
};

  return (
    <>
    <MUIDataTable
        data={spocList}
        columns={columns}
        options={options}
    />
    
    <AlertDialog openDialog={openDialog} handleDialog={() => handleDialog({...openDialog, open: false})}/>
    {/* modal for spoc batch view */}
    <ViewSpocBatch
      show={viewSpocModal}
      onHide={() => setViewSpocModal(false)}
      spocId={tableData[0]}
    />

    <CommentsModalReuse
      show={commentsModal}
      onHide={() => setCommentsModal(false)}
      // commentstomodal={tableData}
      tabledata={tableData}
      modalname="spoccomments"
      postcomment={"/comments/users/add"}
      getcomment={"/comments/users/spoc/"}
      onCloseCallback ={handleCommentsModalClose}

    ></CommentsModalReuse>
    </>
  )
}

function AlertDialog({openDialog, handleDialog}) {
  // console.log(openDialog);
  return (
    <Dialog
      open={openDialog.open}
      onClose={handleDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Deactivate this spoc?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {openDialog.dialogText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='inherit' onClick={handleDialog}>No</Button>
        <Button 
          variant='contained' 
          color='primary' 
          onClick={() => {
            openDialog.deactivate();
            handleDialog();
          }} 
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>

  );
}
